import { IngestionPointCategory } from "./data.ingestion.const";
import { DataIngestionService, IngestionPoint } from "./data.ingestion.service";
import { IngestionAccess } from "./ingestion.access";

export async function loadCopyableIngestionPoints(
    category?: IngestionPointCategory,
    subCategory?: string,
): Promise<IngestionPoint[]> {
    return (
        (await DataIngestionService.getIngestionPoints(
            category,
            subCategory,
            false,
            undefined,
            IngestionAccess.IngestionPointAction.COPY,
        )) ?? []
    );
}

export async function loadCopyableIngestionPointIds(
    category?: IngestionPointCategory,
    subCategory?: string,
): Promise<Set<number>> {
    const points = await loadCopyableIngestionPoints(category, subCategory);
    const copyableIds = new Set<number>();
    for (const point of points) {
        if (point.ingestionPointId != null) {
            copyableIds.add(point.ingestionPointId);
        }
    }
    return copyableIds;
}

export function canCopyIngestionPoint(form: IngestionPoint, copyableIds: Set<number>, canCreateForm: boolean): boolean {
    if (canCreateForm) {
        return true;
    }
    const ingestionPointId = form.ingestionPointId;
    return ingestionPointId != null && copyableIds.has(ingestionPointId);
}
